import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Download, Archive } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const mb = (b) => `${((b || 0) / 1e6).toLocaleString('de-DE', { maximumFractionDigits: 1 })} MB`;

export const FremdSicherungen = () => {
  const [liste, setListe] = useState([]);
  useEffect(() => { axios.get(`${API}/admin/fremdsicherung`).then((r) => setListe(r.data)).catch(() => setListe([])); }, []);

  const laden = async (s) => {
    try {
      const r = await axios.get(`${API}/admin/fremdsicherung/${s.id}/download`, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a'); a.href = url; a.download = s.filename; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch { toast.error('Download fehlgeschlagen'); }
  };

  if (!liste.length) return null;
  return (
    <div className="mt-8 rounded-lg border border-[#E0D6CA] bg-white p-5" data-testid="fremdsicherungen-widget">
      <div className="mb-3 flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.24em] text-[#8E7B71]">
        <Archive className="h-3.5 w-3.5" /> Gesicherte Altsysteme (nur Geschäftsführung)
      </div>
      <ul className="divide-y divide-[#F1E8DF]">
        {liste.map((s) => (
          <li key={s.id} className="flex flex-wrap items-center justify-between gap-2 py-2 text-sm text-[#3D3835]" data-testid={`fremdsicherung-${s.id}`}>
            <div>
              <div className="font-medium">{s.quelle} · {s.beschreibung}</div>
              <div className="text-[11px] text-[#8E7B71]">{new Date(s.erstellt_am).toLocaleString('de-DE')} · {mb(s.file_size)} · {s.filename}</div>
            </div>
            <button onClick={() => laden(s)} data-testid={`fremdsicherung-download-${s.id}`}
              className="inline-flex items-center gap-1 rounded-full border border-[#3D3835] px-3 py-1 text-xs transition-colors hover:bg-[#3D3835] hover:text-white">
              <Download className="h-3 w-3" /> Herunterladen
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
